(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lf-brand-directory"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('lf-brand-directory')){customElements.define('lf-brand-directory',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.controller=new AbortController;const options={signal:this.controller.signal};this.search=this.querySelector('[data-brand-search]');this.sort=this.querySelector('[data-brand-sort]');this.list=this.querySelector('[data-lf-brand-list]');this.items=[...this.querySelectorAll('[data-lf-brand-name]')];this.counter=this.querySelector('[data-brand-count]');this.clear=this.querySelector('[data-brand-clear]');this.empty=this.querySelector('[data-brand-empty]');this.search.addEventListener('input',()=>this.filter(),options);this.search.addEventListener('keydown',event=>{if(event.key==='Escape'){this.search.value='';this.filter()}},options);this.clear.addEventListener('click',()=>{this.search.value='';this.filter();this.search.focus()},options);this.sort.addEventListener('change',()=>this.sortItems(),options);this.sortItems()}disconnectedCallback(){this.controller?.abort();this.ready=false}normalize(value){return value.normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase().trim()}sortItems(){if(!this.list)return;const direction=this.sort.value==='za'?-1:1;const collator=new Intl.Collator(undefined,{sensitivity:'base',numeric:true});this.items.sort((a,b)=>direction*collator.compare(a.dataset.lfBrandName,b.dataset.lfBrandName));this.items.forEach(item=>this.list.appendChild(item));this.filter()}filter(){const query=this.normalize(this.search.value);let count=0;this.items.forEach(item=>{const visible=this.normalize(item.dataset.lfBrandName).includes(query);item.hidden=!visible;if(visible)count++});this.counter.textContent=this.counter.dataset.template.replace('COUNT',String(count));this.clear.hidden=!query;this.empty.hidden=count!==0}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-brand-edit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lf-brand-edit')) {
    class LFBrandEdit extends HTMLElement {
      connectedCallback() {
        if (this._started) return;
        this._started = true;
        this._motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this._cancel = () => this.getAnimations({ subtree: true }).forEach(animation => animation.cancel());
        this.addEventListener('focusin', this._cancel);
        this._onMotion = () => { if (this._motion.matches) { this._observer?.disconnect(); this._cancel(); } };
        this._motion.addEventListener('change', this._onMotion);
        if (this._motion.matches || !('IntersectionObserver' in window) || !Element.prototype.animate || (window.Shopify && window.Shopify.designMode)) return;
        // Content is visible by default. Animation only begins after intersection;
        // unavailable or interrupted JavaScript can never leave products hidden.
        this._observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this._observer.unobserve(entry.target);
            if (this._motion.matches || entry.target.contains(document.activeElement)) return;
            const delay = Number(getComputedStyle(entry.target).getPropertyValue('--lf-card-delay')) || 0;
            entry.target.animate([
              { opacity: 0, transform: 'translateY(14px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ], { duration: 520, delay: Math.min(delay, 180), easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'backwards' });
          });
        }, { threshold: .08, rootMargin: '0px 0px -24px 0px' });
        this.querySelectorAll('[data-brand-reveal]').forEach(element => this._observer.observe(element));
      }
      disconnectedCallback() {
        this._observer?.disconnect();
        this._motion?.removeEventListener('change', this._onMotion);
        this.removeEventListener('focusin', this._cancel);
        this._started = false;
      }
    }
    customElements.define('lf-brand-edit', LFBrandEdit);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-caneza-films"] && !Shopify.designMode) return;
  try {
    
function initializeCanezaFilms(root=document){
  root.querySelectorAll('.lf-films__video').forEach(video=>{
    if(video.dataset.autoplayReady)return;
    video.dataset.autoplayReady='true';
    const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
    if(reducedMotion.matches){video.autoplay=false;video.pause()}
    reducedMotion.addEventListener('change',event=>{if(event.matches){video.autoplay=false;video.pause()}});
  });
}
initializeCanezaFilms();
document.addEventListener('shopify:section:load',event=>initializeCanezaFilms(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-company-stores"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lf-store-directory')) {
  class LFStoreDirectory extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.search = this.querySelector('[data-search]');
      this.region = this.querySelector('[data-region]');
      this.cards = Array.from(this.querySelectorAll('[data-store]'));
      this.count = this.querySelector('[data-count]');
      this.empty = this.querySelector('[data-empty]');
      if (!this.search || !this.region || !this.cards.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.search.addEventListener('input', () => this.filter(), options);
      this.region.addEventListener('change', () => this.filter(), options);
      this.querySelectorAll('[data-clear]').forEach(button => {
        button.addEventListener('click', () => {
          this.search.value = '';
          this.region.value = '';
          this.filter();
          this.search.focus();
        }, options);
      });
      this.querySelector('[data-controls]').hidden = false;
      this.filter();
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = null;
    }
    normalize(value) {
      return value.normalize('NFD').replace(/[̀-ͯ]/g, '').toLocaleLowerCase().trim();
    }
    filter() {
      const terms = this.normalize(this.search.value).split(/\s+/).filter(Boolean);
      const region = this.region.value;
      let total = 0;
      this.cards.forEach(card => {
        const text = this.normalize(card.dataset.searchText || '');
        const matches = (!region || card.dataset.storeRegion === region) && terms.every(term => text.includes(term));
        card.hidden = !matches;
        if (matches) total += 1;
      });
      this.count.textContent = (this.dataset.countPattern || '').replace('[count]', String(total));
      this.empty.hidden = total > 0;
      this.querySelector('.lf-stores__results-bar [data-clear]').hidden = terms.length === 0 && !region;
    }
  }
  customElements.define('lf-store-directory', LFStoreDirectory);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-editorial-hero"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('lf-editorial-hero')){
 customElements.define('lf-editorial-hero',class extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;this.abort=new AbortController();const opts={signal:this.abort.signal};
   this.track=this.querySelector('[data-lf-track]');this.slides=[...this.querySelectorAll('[data-lf-slide]')];this.dots=[...this.querySelectorAll('[data-lf-dot]')];this.count=this.querySelector('[data-lf-count]');this.toggle=this.querySelector('[data-lf-toggle]');this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.index=0;this.visible=false;this.hovered=false;this.focused=false;this.dragging=false;this.paused=this.dataset.autoplay!=='true'||this.motion.matches;
   this.querySelector('[data-lf-prev]')?.addEventListener('click',()=>this.go(this.index-1,true),opts);
   this.querySelector('[data-lf-next]')?.addEventListener('click',()=>this.go(this.index+1,true),opts);
   this.dots.forEach((dot,index)=>dot.addEventListener('click',()=>this.go(index,true),opts));
   this.toggle?.addEventListener('click',()=>{this.paused=!this.paused;this.sync()},opts);
   this.track.addEventListener('keydown',e=>{if(e.target!==this.track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.go(this.index+(e.key==='ArrowRight'?1:-1),true)}},opts);
   this.addEventListener('mouseenter',()=>{this.hovered=matchMedia('(hover: hover)').matches;this.sync()},opts);this.addEventListener('mouseleave',()=>{this.hovered=false;this.sync()},opts);
   this.addEventListener('focusin',e=>{this.focused=e.target!==this.toggle;this.sync()},opts);this.addEventListener('focusout',()=>{queueMicrotask(()=>{this.focused=this.contains(document.activeElement)&&document.activeElement!==this.toggle;this.sync()})},opts);
   this.track.addEventListener('pointerdown',()=>{this.dragging=true;this.sync()},opts);window.addEventListener('pointerup',()=>{if(this.dragging){this.dragging=false;this.sync()}},opts);window.addEventListener('pointercancel',()=>{this.dragging=false;this.sync()},opts);
   document.addEventListener('visibilitychange',()=>this.sync(),opts);this.motion.addEventListener('change',()=>{if(this.motion.matches)this.paused=true;this.sync()},opts);
   this.observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting&&entry.intersectionRatio>.6)this.setActive(this.slides.indexOf(entry.target))})},{root:this.track,threshold:.65});this.slides.forEach(slide=>this.observer.observe(slide));
   this.viewportObserver=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync()},{threshold:.15});this.viewportObserver.observe(this);
   this.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.contains(e.target)||s===e.target);if(i>=0){this.paused=true;this.go(i,true)}},opts);this.setActive(0);this.sync();
  }
  disconnectedCallback(){clearTimeout(this.timer);this.observer?.disconnect();this.viewportObserver?.disconnect();this.abort?.abort();this.ready=false}
  sync(){clearTimeout(this.timer);if(this.toggle){this.toggle.textContent=this.paused?this.toggle.dataset.playLabel:this.toggle.dataset.pauseLabel;this.toggle.setAttribute('aria-label',this.paused?this.toggle.dataset.playLabel:this.toggle.dataset.pauseLabel)}if(this.count)this.count.setAttribute('aria-live',this.paused?'polite':'off');if(!this.paused&&!this.hovered&&!this.focused&&!this.dragging&&this.visible&&!document.hidden&&this.slides.length>1){this.timer=setTimeout(()=>this.go(this.index+1,false),Number(this.dataset.interval)||6000)}}
  go(index,manual){if(!this.slides.length)return;const target=(index+this.slides.length)%this.slides.length;const img=this.slides[target].querySelector('img');if(img)img.loading='eager';if(manual&&this.count)this.count.setAttribute('aria-live','polite');this.track.scrollTo({left:this.slides[target].offsetLeft-this.track.offsetLeft,behavior:this.motion.matches?'auto':'smooth'});this.sync()}
  setActive(index){this.index=index;this.dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===index)));this.slides.forEach((slide,i)=>{slide.setAttribute('aria-hidden',String(i!==index));slide.inert=i!==index;slide.classList.toggle('is-active',i===index)});if(this.count)this.count.textContent=`${index+1} / ${this.slides.length}`;this.sync()}
 });
}

  } catch(e) { console.error(e); }
})();
})();
